import React, {Component} from 'react'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import ExportButton from './ExportButton'
import {translate} from 'react-i18next'
import PropTypes from 'prop-types';


class ExportDialog extends Component {
    state = {
        open: false
    }

    handleOpen = () => {
        this.setState({open: true})
    }

    handleClose = () => {
        this.setState({open: false})
    }

    render() {
        const actions = [
            <FlatButton
                label={this.props.t('dialog_dismiss')}
                // primary={true}
                onClick={this.handleClose}
                key="cancel"
            />,
        ];
        const csvDownloadUrl = `${process.env.REACT_APP_API_BASE_URL}packages/${this.props.package.id}/export/csv/`
        const pdfDownloadUrl = `${process.env.REACT_APP_API_BASE_URL}packages/${this.props.package.id}/export/pdf/`
        const pdfPrintableDownloadUrl = `${process.env.REACT_APP_API_BASE_URL}packages/${this.props.package.id}/export/printable-pdf/`

        return (
            <FlatButton onClick={this.handleOpen} label={this.props.t('export_button_text')}>
                <Dialog actions={actions} autoScrollBodyContent={true} open={this.state.open} title={this.props.t('export_button_text')}>
                    <p>{this.props.t('export_csv_intro')}</p>
                    <ExportButton
                        package={this.props.package}
                        label={this.props.t('export_csv_button_text')}
                        contentType="data:text/csv;charset=utf-8,"
                        extension={"csv"}
                        downloadUrl={csvDownloadUrl}
                    />
                    {process.env.REACT_APP_ENABLE_PDF_EXPORT === '1' && <p style={{marginTop: '35px'}}>{this.props.t('export_pdf_intro')}</p>}
                    {process.env.REACT_APP_ENABLE_PDF_EXPORT === '1' && <ExportButton
                        package={this.props.package}
                        label={this.props.t('export_pdf_button_text')}
                        contentType="data:application/pdf;base64,"
                        extension={"pdf"}
                        downloadUrl={pdfDownloadUrl}

                    />}
                    {process.env.REACT_APP_ENABLE_PDF_EXPORT === '1' && <p style={{marginTop: '35px'}}>{this.props.t('export_printable_pdf_intro')}</p>}
                    {process.env.REACT_APP_ENABLE_PDF_EXPORT === '1' && <ExportButton
                        package={this.props.package}
                        label={this.props.t('export_printable_pdf_button_text')}
                        contentType="data:application/pdf;base64,"
                        extension={"pdf"}
                        downloadUrl={pdfPrintableDownloadUrl}

                    />}
                </Dialog>

            </FlatButton>
        )
    }


}

ExportDialog.propTypes = {
    'package': PropTypes.object.isRequired
}

export default translate()(ExportDialog)


// WEBPACK FOOTER //
// ./src/components/packages/export/ExportDialog.js